import { render, staticRenderFns } from "./BidFileLogsList.vue?vue&type=template&id=57f456e1&scoped=true&"
import script from "./BidFileLogsList.vue?vue&type=script&lang=js&"
export * from "./BidFileLogsList.vue?vue&type=script&lang=js&"
import style0 from "./BidFileLogsList.vue?vue&type=style&index=0&id=57f456e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f456e1",
  null
  
)

export default component.exports